
export default
	props:
		show:	default: true
		onClick: type: Function
		renderAsDiv: type: Boolean
		color:
			type: String
			default: "yellow"
			validator: (val) -> val in ["yellow", "yellow-sun", "white", "black"]
		size:
			type: String
			default: "normal"
			validator: (val) -> val in ["normal", "small"]
		highlight:
			type: String
			default: "none"
			validator: (val) -> val in ["none", "resonate", "circular-blur", "outer-blur", "inner-blur"]

	computed:
		component: -> if @renderAsDiv then 'div' else 'button'
		classes: -> [
			"color-#{@color || 'yellow'}"
			"size-#{@size || 'normal'}"
			"highlight-#{@highlight || 'none'}"
		]

	methods: click: -> @$emit 'click'
